export interface WeeklyRange {
  name: string;
  value: string;
  min: number;
  max: number;
}

export const WeeklyRanges: WeeklyRange[] = [
  {
    name: "-0.1 עד -0.3 ק\"ג",
    value: "X_SMALL_MINUS",
    min: -0.1,
    max: -0.3,
  },
  {
    name: "-0.2 עד -0.4 ק\"ג",
    value: "SMALL_MINUS",
    min: -0.2,
    max: -0.4,
  },
  {
    name: "-0.3 עד -0.5 ק\"ג",
    value: "MEDIUM_MINUS",
    min: -0.3,
    max: -0.5,
  },
  {
    name: "-0.4 עד -0.6 ק\"ג",
    value: "X_MEDIUM_MINUS",
    min: -0.4,
    max: -0.6,
  },
  {
    name: "-0.5 עד -0.8 ק\"ג",
    value: "LARGE_MINUS",
    min: -0.5,
    max: -0.8,
  },
  {
    name: "-0.7 עד -1 ק\"ג",
    value: "X_LARGE_MINUS",
    min: -0.7,
    max: -1,
  },
  {
    name: "+0.1 עד +0.3 ק\"ג",
    value: "X_SMALL_PLUS",
    min: 0.1,
    max: 0.3,
  },
  {
    name: "+0.2 עד +0.4 ק\"ג",
    value: "SMALL_PLUS",
    min: 0.2,
    max: 0.4,
  },
  {
    name: "+0.3 עד +0.5 ק\"ג",
    value: "MEDIUM_PLUS",
    min: 0.3,
    max: 0.5,
  },
  {
    name: "+0.4 עד +0.6 ק\"ג",
    value: "X_MEDIUM_PLUS",
    min: 0.4,
    max: 0.6,
  },
  {
    name: "+0.5 עד +0.8 ק\"ג",
    value: "LARGE_PLUS",
    min: 0.5,
    max: 0.8,
  },
  {
    name: "+0.7 עד +1 ק\"ג",
    value: "X_LARGE_PLUS",
    min: 0.7,
    max: 1,
  },
  {
    name: "-0.2 עד +0.2 ק\"ג",
    value: "MAINTENANCE",
    min: -0.2,
    max: 0.2,
  },
]
